// Simple audio chime + browser notification helper for the admin dashboard.
// Uses Web Audio API - no external assets needed.

let audioCtx = null;

function ensureAudioCtx() {
  if (typeof window === 'undefined') return null;
  if (!audioCtx) {
    try {
      audioCtx = new (window.AudioContext || window.webkitAudioContext)();
    } catch (e) { return null; }
  }
  return audioCtx;
}

// Gentle two-note chime (D5 -> F#5)
export function playChime() {
  const ctx = ensureAudioCtx();
  if (!ctx) return;
  const now = ctx.currentTime;
  const notes = [
    { freq: 587.33, start: 0, dur: 0.35 },      // D5
    { freq: 739.99, start: 0.18, dur: 0.55 },   // F#5
  ];
  notes.forEach((n) => {
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = 'sine';
    osc.frequency.value = n.freq;
    osc.connect(gain);
    gain.connect(ctx.destination);
    gain.gain.setValueAtTime(0.0001, now + n.start);
    gain.gain.exponentialRampToValueAtTime(0.18, now + n.start + 0.03);
    gain.gain.exponentialRampToValueAtTime(0.0001, now + n.start + n.dur);
    osc.start(now + n.start);
    osc.stop(now + n.start + n.dur + 0.05);
  });
}

export async function requestNotificationPermission() {
  if (typeof window === 'undefined' || !('Notification' in window)) return 'unsupported';
  if (Notification.permission === 'granted') return 'granted';
  if (Notification.permission === 'denied') return 'denied';
  try {
    const p = await Notification.requestPermission();
    return p;
  } catch { return 'error'; }
}

export function showBrowserNotification(title, body) {
  if (typeof window === 'undefined' || !('Notification' in window)) return;
  if (Notification.permission !== 'granted') return;
  try {
    const n = new Notification(title, { body, icon: '/favicon.ico', tag: 'vedyah-chat' });
    n.onclick = () => { window.focus(); n.close(); };
    setTimeout(() => n.close(), 8000);
  } catch {}
}
